var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgValveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.14286C0 4.51168 0.488417 4 1.09091 4H22.9091C23.5116 4 24 4.51167 24 5.14286V18.8571C24 19.4883 23.5116 20 22.9091 20H1.09091C0.488417 20 0 19.4883 0 18.8571V5.14286Z",
    fill: "#74797D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.85714C2 6.38376 2.40701 6 2.90909 6H21.0909C21.593 6 22 6.38376 22 6.85714V17.1429C22 17.6162 21.593 18 21.0909 18H2.90909C2.40701 18 2 17.6162 2 17.1429V6.85714Z",
    fill: "#CDD0D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 15V15.7583L5.19696 15.4596L12 12.544L18.803 15.4596L19.5 15.7583V15V9V8.24173L18.803 8.54043L12 11.456L5.19696 8.54043L4.5 8.24173V9V15Z",
    fill: "white",
    stroke: "#74797D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValveIcon);
export default __webpack_public_path__ + "static/media/valve-icon.b4bb806a6a59da85491e715357772e44.svg";
export { ForwardRef as ReactComponent };